/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies */
import Controller from '@ember/controller';
import { isArray } from '@ember/array';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import Options from '@linc-technologies/linced-common/enums/options';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import {
  getCurrentMilestone,
  generateExpectationData,
  generateProgressData,
} from '@linc-technologies/linced-common/utils/progressions';

export default class SubjectController extends Controller {
  @service
  colours;

  @service
  session;

  @service
  dates;

  @service
  options;

  queryParams = ['topic'];
  topic = null;
  topics = [];

  @computed('session.activeSchool')
  get progressChartColors() {
    return this.colours.charts(this.session.school);
  }

  @optionAlias(Options.CHARTS_SHOW_ALL_COLOURS)
  showAllColours;
  @optionAlias('hero:lock:milestones')
  milestonesLocked;

  @computed('model.levels.@each.sequence')
  get levels() {
    return this.model.levels
      .slice()
      .sort(
        (a, b) =>
          a.sequence - b.sequence ||
          (a.label || '').localeCompare(b.label || ''),
      );
  }

  @alias('model.subject.milestones')
  milestones;

  @computed('model.{milestones.[],group.learners.[]}')
  get learnerMilestones() {
    let members = this.get('model.group.sortedCurrentLearners');
    if (!isArray(members)) {
      return {};
    }
    return members.reduce((map, member) => {
      let person = member.get('person');
      map[person.id] = getCurrentMilestone(
        this.milestones,
        person,
        this.dates.rolloverMonthDate,
      );
      return map;
    }, {});
  }

  @computed('model.{milestones.[],levels.[],expectations.[]}')
  get expectations() {
    return generateExpectationData(
      this.model.expectations,
      this.milestones,
      this.levels,
      this.showAllColours,
    );
  }

  @computed('model.{progressions.[],group.learners.[]}')
  get learnerProgressions() {
    let members = this.get('model.group.sortedCurrentLearners');
    if (!isArray(members)) {
      return {};
    }

    // Build initial empty map of personId -> array.
    let map = members.reduce((map, member) => {
      let person = member.get('person');
      map[person.id] = [];
      return map;
    }, {});

    // Populate with records.
    let progressions = this.get('model.progressions');
    if (!isArray(progressions)) {
      return map;
    }
    return progressions.reduce((map, progression) => {
      let personId = progression.person_id;
      // Ignore people who aren't current group members, since we won't show them anyway.
      if (isArray(map[personId])) {
        map[personId].push(progression);
      }
      return map;
    }, map);
  }

  @action
  currentMilestone(person) {
    return this.get(`learnerMilestones.${person.id}`);
  }

  @action
  previousMilestone(currentMilestone) {
    let currentIndex = this.milestones.indexOf(currentMilestone);
    return this.milestones[currentIndex - 1];
  }

  @action
  chartData(records) {
    return generateProgressData(this.milestones, this.levels, records);
  }

  @action
  updateRecords() {
    this.model.progressions.update();
  }

  @action
  addTopic() {
    let topic = this.topic;
    if (topic && !this.topics.includes(topic)) {
      this.topics = [...this.topics, topic]; // Ensure it's added to the array
    }
  }
}
